<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="flex" style="align-items: none"> 
  <!-- 左侧面板 -->
  <div class="w-80 border-r border-gray-200">
  <!-- 客服切换区域 -->
  <div class="p-4 border-b border-gray-200">
  <div class="flex items-center space-x-3 mb-4 relative">
  <div class="relative">
  <img :src="currentAgent.avatarUrl" alt="客服头像" class="w-12 h-12 rounded-full object-cover">
  <div :class="['absolute bottom-0 right-0 w-3 h-3 rounded-full',
  currentAgent.is_online === 1 ? 'bg-green-500' : 'bg-gray-400']"></div>
  </div>
  <div class="flex-1">
  <h3 class="font-medium">{{ currentAgent.nickName }}</h3>
  <p class="text-sm text-gray-500">
                {{ 
                { 0: '未在线', 1: '在线', 2: '离开' }[currentAgent.is_online] || '未知状态' 
                }}
                </p>
  </div>
  <button @click="showAgentSelect = !showAgentSelect" class="text-gray-400 hover:text-gray-600 !rounded-button">
  <i class="fas fa-chevron-down"></i>
    切换客服
  </button>
  <!-- 客服选择下拉面板 -->
  <div v-if="showAgentSelect" class="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
      <div v-for="agent in agents" 
           :key="agent.id" 
           @click="selectAgent(agent)"
           class="p-3 hover:bg-gray-50 cursor-pointer flex items-center space-x-3">
          <div class="relative">
              <img :src="agent.avatarUrl" alt="客服头像" class="w-10 h-10 rounded-full object-cover">
              <div :class="['absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full',
                  agent.status === 'online' ? 'bg-green-500' : 'bg-gray-400']"></div>
          </div>
          <div class="flex-1">
              <h4 class="font-medium">{{ agent.nickName }}</h4>
              <p class="text-sm text-gray-500">
                {{ 
                { 0: '未在线', 1: '在线', 2: '离开' }[agent.is_online] || '未知状态' 
                }}
                </p>
          </div>
      </div>
  </div>
  </div>
  <div class="flex space-x-2">
    <div class="flex space-x-2">
  <button 
    v-for="status in statusOptions"
    :key="status.value"
    @click="changeStatus(status.value)"
    :class="[
      'px-3 py-1 text-sm !rounded-button whitespace-nowrap',
      currentAgent.is_online === statusMap[status.value] 
        ? 'bg-blue-500 text-white' 
        : 'bg-gray-100 text-gray-600'
    ]">
    {{ status.label }}
  </button>
</div>
  </div>
  </div>
  <!-- 用户列表 -->
  <div class="flex-1 overflow-y-auto" style="height: 480px;">
    <!-- 添加搜索框 -->
    <div class="p-3 border-b border-gray-200 sticky top-0 bg-white z-10">
    <div class="relative">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="搜索好友..."
        class="w-full p-2 pl-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
      <i class="fas fa-search absolute left-2 top-3 text-gray-400"></i>
    </div>
  </div>
  <div v-for="user in searchedUsers"
  :key="user.id"
  @click="selectUser(user)"
  :class="[
  'p-4 hover:bg-gray-50 cursor-pointer',
  selectedUser.id === user.id ? 'bg-gray-50' : ''
  ]">
  <div class="flex items-center space-x-3">
  <img :src="user.receiver.avatarUrl" alt="用户头像" class="w-10 h-10 rounded-full object-cover">
  <div class="flex-1 min-w-0">
  <div class="flex justify-between items-center">
  <h4 class="font-medium truncate">{{ user.receiver.nickName }}</h4>
  <!-- <span class="text-xs text-gray-500">{{ user.lastMessageTime }}</span> -->
  </div>
  <!-- <p class="text-sm text-gray-500 truncate">{{ user.lastMessage }}</p> -->
  </div>
  </div>
  </div>
  </div>
  </div>
  <!-- 修改模板部分 -->
<!-- 消息容器部分 -->
<div class="flex-1 p-4" ref="messageContainer" style="height: 530px; z-index: 500; overflow-y: auto;">
  <div v-for="item in chatHistory.messages" 
       :key="item.id" 
       class="mb-4">
       <!-- 普通消息-右边 -->
       <div v-if="item.sender.user_id === currentAgent.user_id " >
      <div :class="[
        'flex items-start',
        item.userid === currentAgent.user_id ? 'justify-end' : 'justify-start'
      ]">
  
        <!-- 消息主体容器 -->
        <div class="max-w-[70%] flex items-start gap-3 flex-row-reverse"
             :class="item.userid === currentAgent.user_id ? 'flex-row-reverse' : ''">
          
          <!-- 头像 -->
          <img :src="item.userid === currentAgent.user_id?(currentAgent.avatarUrl || defaultAvatar):currentAgent.avatarUrl || defaultAvatar"
               class="w-8 h-8 rounded-full object-cover flex-shrink-0">
          
          <!-- 消息内容 -->
          <div :class="[
            'p-3 rounded-lg',
            item.userid === currentAgent.user_id 
              ? 'bg-blue-500 text-white order-1' 
              : 'bg-gray-100 order-2'
          ]">
            <!-- 消息内容 -->
            <template v-if="item.message.type === 'text'">
              <div v-if="item.status === 'sending'" class="text-xs text-gray-400">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <p>{{ item.message.content }}</p>
            </template>

            <!-- 消息内容订单 -->
            <template v-if="item.message.type === 'order'">
              <div @click="goOrder(item.message.content)">
                <div v-if="item.status === 'sending'" class="text-xs text-gray-400">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>

                您购买的商品商家已处理
              <p style="color: #e8a23a;float: right; margin-left: 12px;">查看</p>
              </div>
            </template>

             <!-- 消息内容图片 -->
             <template v-if="item.message.type === 'image'">
              <img class="art_img"
              :src="item.message.content" 
             /> 
            </template>

             <!-- 消息内容  视频 -->
             <template v-if="item.message.type === 'video'">
              <video :src="item.message.content" controls
              style="object-fit: contain;">
            </video>
            </template>

            <template v-if="item.message.type === 'system_tip1'">
              <div class="payment-reminder" @click="handleClick(item.content)">
                <div class="reminder-header">           
                  <span class="title">待支付提醒</span>
               </div>
               <div class="reminder-content">
                <span>订单号：{{ parsedOrder(item.obj).order_no }}</span>
                <span class="amount">应付金额：¥{{ formattedAmount(parsedOrder(item.obj).total) }}</span>
              </div>
            </div>
            </template>

            <template v-if="item.message.type === 'friend'">

              <div 
      class="user-card" 
      style="position: relative;" 
      @click="handleUserCardClick(itemsa.obj)"
    >
      <!-- 用户头像 -->
      <img 
        class="user-avatar" 
        :src="parsedUserObj.avatarUrl"
      />
      <!-- 用户名 -->
      <span class="user-name">{{ parsedUserObj.nickName }}</span>

      <div 
        class="view-button" 
        @click.stop="handleSendUrl(product)"
      >
        查看
      </div>
      </div>
            </template>


            <template v-if="item.message.type === 'voice'">
              <div class="voiceaa" @click="audioClick(index, item)">
      <audio :src="item.message.content" :ref="'audios_'+index" style="opacity: 0; height: 0; width: 0;" controls></audio>
      <img src="@/assets/chat/a.png" style="position: absolute; top: -10px; left: 38%;" />
    </div>
            </template>

            <template v-if="item.message.type === 'url'">
              <div class="isclipboardText">
      <div class="item" v-if="item.message.content.product_id"
        @click="gotoList(item.message.content.product_id)">
        <div class="product-cover">
          <img :src="item.message.content.product_image" />
        </div>
        <div class="product-info" style="width: 300px;">
          <div class="product-title">
            {{ item.message.content.product_name }}
          </div>
          <div class="already-sale">
            <span>已售{{ item.message.content.product_sales }}件</span>
          </div>
          <div class="price mt20">
            {{ currencySymbol }}
            <span class="num">{{ item.message.content.product_sku
                              ? item.message.content.product_sku.product_price : '' }}</span>
          </div>
        </div>
      </div>
      <div class="item" v-else-if="
                    item.obj &&
                  parsedObj(item.obj).product && 
                    parsedObj(item.obj).product.product_id" 
                    @click="gotoList(parsedObj(item.obj).product.product_id)">
        <div class="product-cover">
          <img :src="parsedObj(item.obj).product.product_image" />
        </div>
        <div class="product-info" style="width: 300px;">
          <div class="product-title">
            {{ parsedObj(item.obj).product.product_name }}
          </div>
          <div class="already-sale">
            <span>已售{{ parsedObj(item.obj).product.product_sales }}件</span>
          </div>
          <div class="price mt20">
            {{ currencySymbol }}
            <span class="num">{{ parsedObj(item.obj).product.product_price }}</span>
          </div>
        </div>
      </div>
    </div>
            </template>

            <template v-if="item.message.type === 'file'">
              <div 
              v-if="item.message.type === 'file'" 
              @click="handleFileClick(item.message.content.src)"
              >
              <div class="message-container">
                <div class="file-container">
                  <span class="file-name">{{ item.message.content.real_name }}</span>
                </div>
              </div>
            </div>
            </template>

          </div>
        </div>
      </div>
    </div>

    <!-- 普通消息-左边 -->
    <div v-else>
      <div :class="[
        'flex items-start',
        item.userid === selectedUser.receiver.user_id ? 'justify-start' : 'justify-start'
      ]">

        <!-- 消息主体容器 -->
        <div class="max-w-[70%] flex items-start gap-3" 
     :class="item.userid === selectedUser.receiver.user_id ? 'flex-row' : 'flex-row-reverse'">
  
  <!-- 头像 -->
  <img :src="item.sender.avatarUrl || defaultAvatar"
       class="w-8 h-8 rounded-full object-cover flex-shrink-0">
  
  <!-- 消息内容 -->
  <div :class="[
    'p-3 rounded-lg',
    item.userid === selectedUser.receiver.user_id 
      ? 'bg-blue-500 text-white' 
      : 'bg-gray-100'
  ]">
            <!-- 消息内容 -->
            <template v-if="item.message.type === 'text'">
              <div v-if="item.status === 'sending'" class="text-xs text-gray-400">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <p>{{ item.message.content.replace(/^"+|"+$/g, '') }}</p>
            </template>

             <!-- 消息内容订单 -->
             <template v-if="item.message.type === 'order'">
              <div @click="goOrder(item.message.content)">
                <div v-if="item.status === 'sending'" class="text-xs text-gray-400">
                  <i class="fas fa-spinner fa-spin"></i>
                </div>

                您购买的商品商家已处理
              <p style="color: #e8a23a;float: right; margin-left: 12px;">查看</p>
              </div>
            </template>

             <!-- 消息内容图片 -->
             <template v-if="item.message.type === 'image'">
              <img class="art_img"
              :src="item.message.content" 
             />
            </template>

            
             <!-- 消息内容  视频 -->
             <template v-if="item.message.type === 'video'">
              <video :src="item.message.content" controls
              style="object-fit: contain;">
            </video>
            </template>

            <template v-if="item.message.type === 'system_tip1'">
              <div class="payment-reminder" @click="handleClick(item.content)">
                <div class="reminder-header">           
                  <span class="title">待支付提醒</span>
               </div>
               <div class="reminder-content">
                <span>订单号：{{ parsedOrder(item.obj).order_no }}</span>
                <span class="amount">应付金额：¥{{ formattedAmount(parsedOrder(item.obj).total) }}</span>
              </div>
            </div>
            </template>

            <template v-if="item.message.type === 'friend'">
              <div class="user-card" style="position: relative;" @click="userCard(item.obj)">
      <!-- 用户头像 -->
      <img class="user-avatar" :src="parsedObj(item.obj).avatarUrl || 'default-avatar.png'" />
      <!-- 用户名 -->
      <span class="user-name">{{ parsedObj(item.obj).nickName }}</span>

      <div @click.stop="sendUrl(product)"
        style="font-size: 13px; position: absolute; right: 10px; bottom: 5px; color: #6f6f6f;">
        查看
      </div>
    </div>
            </template>


            <template v-if="item.message.type === 'voice'">
              <div class="voiceaa" @click="audioClick(index, item)">
      <audio :src="item.message.content" :ref="'audios_'+index" style="opacity: 0; height: 0; width: 0;" controls></audio>
      <img src="@/assets/chat/a.png" style="position: absolute; top: -10px; left: 38%;" />
    </div>
            </template>

            <template v-if="item.message.type === 'url'">
              <div class="isclipboardText">
      <div class="item" v-if="item.message.content.product_id"
        @click="gotoList(item.message.content.product_id)">
        <div class="product-cover">
          <img :src="item.message.content.product_image" />
        </div>
        <div class="product-info" style="width: 300px;">
          <div class="product-title">
            {{ item.message.content.product_name }}
          </div>
          <div class="already-sale">
            <span>已售{{ item.message.content.product_sales }}件</span>
          </div>
          <div class="price mt20">
            {{ currencySymbol }}
            <span class="num">{{ item.message.content.product_sku
                              ? item.message.content.product_sku.product_price : '' }}</span>
          </div>
        </div>
      </div>
      <div class="item" v-else-if="
                    item.obj &&
                  parsedObj(item.obj).product && 
                    parsedObj(item.obj).product.product_id" 
                    @click="gotoList(parsedObj(item.obj).product.product_id)">
        <div class="product-cover">
          <img :src="parsedObj(item.obj).product.product_image" />
        </div>
        <div class="product-info" style="width: 300px;">
          <div class="product-title">
            {{ parsedObj(item.obj).product.product_name }}
          </div>
          <div class="already-sale">
            <span>已售{{ parsedObj(item.obj).product.product_sales }}件</span>
          </div>
          <div class="price mt20">
            {{ currencySymbol }}
            <span class="num">{{ parsedObj(item.obj).product.product_price }}</span>
          </div>
        </div>
      </div>
    </div>
            </template>

            <template v-if="item.message.type === 'file'">
              <div 
              @click="downloadFile(item.message.content.src)"
              >
              <div class="message-container">
                <div class="file-container">
                  <span class="file-name">{{ item.message.content.real_name }}</span>
                </div>
              </div>
            </div>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="border-t p-4" style="position: absolute; bottom: 50px; width: 725px;">
    <div class="flex space-x-2">
      <input
        v-model="message"
        @keyup.enter="message"
        placeholder="输入消息..."

   
        class="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
      <button
        @click="sendMessage"
        class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 !rounded-button"
      >
        发送
      </button>
    </div>
  </div>
</div>
  <!-- 历史记录弹窗 -->
  <div v-if="showHistory" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
  <div class="bg-white rounded-lg w-2/3 h-3/4 flex" style="position: relative;">
    <!-- <div class="p-4 border-b border-gray-200 flex justify-between items-center">
    <h3 class="font-medium">聊天记录</h3>
    <button @click="showHistory = false" class="text-gray-600 hover:text-gray-800 !rounded-button whitespace-nowrap">
    <i class="fas fa-times"></i>
    </button>
    </div> -->
    <div>    
      <button @click="showHistory = false"  
      style="position: absolute;right: 10px;top: 10px;"
      class="text-gray-600 hover:text-gray-800 !rounded-button whitespace-nowrap">
    <i class="fas fa-times"></i>
    关闭
    </button>
  </div>
  <div class="flex-1 p-5" >
  <div v-for="record in chatHistory" :key="record.id" class="mb-4">
  <!-- <div class="text-center text-sm text-gray-500 mb-2">{{ record.date }}</div> -->
  <div v-for="message in record.messages"
  :key="message.id"
  class="mb-2 flex items-start space-x-3"
  :class="message.isSelf ? 'flex-row-reverse space-x-reverse' : ''">
  <img :src="message.avatarUrl" alt="头像" class="w-8 h-8 rounded-full object-cover">
  <div :class="[
  'max-w-[70%] p-3 rounded-lg',
  message.isSelf ? 'bg-blue-500 text-white' : 'bg-gray-100'
  ]">
  <p>{{ message.content }}</p>
  <span :class="[
  'text-xs mt-1 block',
  message.isSelf ? 'text-blue-100' : 'text-gray-500'
  ]">{{ message.time }}</span>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </template>
  <script>
  import UserApi from '@/api/user.js'
  const config = require('../../../../config');  // 根据项目路径调整
  export default {
    props: {
    list: {
      type: Object,
      default: () => ({ data: [] })
    },
    // currentUserId: {
    //   type: [Number, String],
    //   required: true
    // }
  },
  name: 'App',
  data() {
  return {
  showAgentSelect: false, // 控制客服选择面板的显示
  currentAgent: {},
  message: '', // 新增消息输入绑定
  agents: [],
  searchQuery: '', // 搜索关键词
  filteredUsers: [], // 过滤后的用户列表
  websocket: null,
    websocketRetryCount: 0,
    maxRetryCount: 3,
    isPageActive: true,
  statusMap: {  // 状态映射关系
      'offline': 0,
      'online': 1,
      'busy': 2
    },
    statusOptions: [
      { label: '在线', value: 'online' },
      { label: '离开', value: 'busy' },
      { label: '离线', value: 'offline' }
    ],
  users: [

  ],
  selectedUser: {},
  socket: null,
  newMessage: '',
  showHistory: false,
  chatHistory: [
  {
  date: '2024-01-20',
  messages: []
  }
  ],

  
  };
  },
  created() {
    this.setupPageVisibilityListener();
  this.selectedUser = this.users[0];
  UserApi.userlistx({ role:'service'}).then(data => {
          console.log("user",data.data.list.data);
          this.agents = data.data.list.data
          this.currentAgent = data.data.list.data[0]
        })
        let id = 0
        if(this.currentAgent.user_id === undefined){
          id = 2
          this.currentAgent.user_id = id
        }else {
          id = this.currentAgent.user_id
        }
        this.getMyFriend(id)
        // this.getChatList(id)
        this.getMsgList( this.selectedUser.sender.user_id,this.selectedUser.receiver.user_id)
  },
  computed: {
  searchedUsers() {
    if (!this.searchQuery) {
      return this.users; // 如果没有搜索词，返回全部用户
    }
    const query = this.searchQuery.toLowerCase();
    return this.users.filter(user => 
      user.receiver.nickName.toLowerCase().includes(query)
    );
  }
},
beforeDestroy() {
  this.closeWebSocket();
  this.removePageVisibilityListener();
  if (this.socket) this.socket.close();
},
  methods: {
    handleSocketOpen(event) {
    console.log('WebSocket 连接成功', event);
  },
  parsedObj(obj) {
      // 替换原来的 getObj() 方法
      try {
        return typeof obj === 'string' ? JSON.parse(obj) : obj;
      } catch (e) {
        console.error('解析对象失败:', e);
        return {};
      }
    },
  downloadFile(url) {
      // 文件下载逻辑
      const link = document.createElement('a');
      link.href = url;
      link.download ='file';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    setupPageVisibilityListener() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  
  removePageVisibilityListener() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  
  handleVisibilityChange() {
    this.isPageActive = !document.hidden;
    if (this.isPageActive && !this.websocket) {
      this.initWebSocketForCurrentUser();
    }
  },
  handleSocketMessage(event) {
    const receivedData = JSON.parse(event.data);
    this.messages.push(receivedData); // 将消息存入数组‌:ml-citation{ref="7" data="citationList"}
  },
  handleSocketError(error) {
    console.error('WebSocket 错误:', error);
  },
  handleSocketClose(event) {
    console.log('WebSocket 连接关闭', event);
  },
     // selectUser 方法
     async selectUser(user) {
      var current_userr_id = this.currentAgent.user_id
  
      this.selectedUser = user;
      this.$forceUpdate();

      await this.initWebSocketForCurrentUser();
      // 获取历史消息
      try {
        const res = await UserApi.getMsgList({
         userid:current_userr_id,  // 当前用户ID
         touid: user.receiver.user_id // 好友用户ID
       });
        console.log('.user.user_id',user)
        // 直接替换整个数组（触发响应式）
   this.chatHistory.messages = res.data.list.map(msg => ({
     ...msg,
      isSelf: msg.userid === this.currentAgent.user_id
   }));

    
   this.$nextTick(() => {
     this.$forceUpdate(); // 仅在极端情况下使用（可选）
   });
        
      } catch (error) {
        console.error('获取消息失败:', error);
      }
    },
    async initWebSocketForCurrentUser() {
    if (!this.isPageActive) return;
    
    // 如果已有有效连接，直接返回
    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
      return;
    }
    
    // 关闭现有连接（如果有）
    this.closeWebSocket();
    
    try {
      await this.initWebSocket();
      console.log('WebSocket 连接已为当前用户建立');

        ///發送一條登錄消息
        const wsMsg = {
        token: this.currentAgent.user_id,
        type: 'login',
        imgUri:this.currentAgent.avatarUrl
      };
      this.websocket.send(JSON.stringify(wsMsg));
      


    } catch (error) {
      console.error('WebSocket 连接失败:', error);
      this.retryWebSocketConnection();
    }
  },
  
  // 重试连接逻辑
  retryWebSocketConnection() {
    if (this.websocketRetryCount < this.maxRetryCount) {
      this.websocketRetryCount++;
      const delay = Math.min(1000 * this.websocketRetryCount, 5000); // 最大延迟5秒
      
      setTimeout(() => {
        this.initWebSocketForCurrentUser();
      }, delay);
    } else {
      console.warn(`WebSocket 连接已尝试 ${this.maxRetryCount} 次，不再重试`);
    }
  },
  

  changeStatus(statusValue) {
    this.currentAgent.is_online = this.statusMap[statusValue]
    UserApi.edituser({user_id: this.currentAgent.user_id,
      grade_id:this.currentAgent.grade.grade_id,
      is_online:this.statusMap[statusValue]}).then(data => {
         console.log("用户在线");
         
        })
  },
  selectAgent(agent) { 
    this.currentAgent = {...agent};
    // this.currentAgent.user_id
    console.log(this.currentAgent);
    this.showAgentSelect = false;

    this.getMyFriend(this.currentAgent.user_id)
    // 更新消息中的客服头像
    this.messages = this.messages.map(msg => {
      if (msg.isSelf) {
          return { ...msg, avatar: agent.avatar };
      }
      return msg;
    });
   
  },
  formatMessage(msg) {
    return {
      ...msg,
      isSelf: msg.userid === this.currentAgent.user_id,
      sender: {
        user_id: msg.userid,
        avatarUrl: msg.sender ? msg.sender.avatarUrl : this.defaultAvatar,
        nickName: msg.sender ? (msg.sender.nickName || '未知用户') : '未知用户'
      },
      receiver: {
        user_id: msg.touid,
        avatarUrl: msg.receiver ? msg.receiver.avatarUrl : this.defaultAvatar,
        nickName: msg.receiver ? (msg.receiver.nickName || '未知用户') : '未知用户'
      },
      message: {
        content: msg.content.replace(/^"+|"+$/g, ''),
        type: msg.type,
        url: msg.url
      }
    };
  },
  scrollToBottom() {
    this.$nextTick(() => {
      const container = this.$refs.messageContainer;
      if (container) {
        container.scrollTop = container.scrollHeight + 112;
      }
    });
  },
  // 格式化消息数据
  formatTime(timestamp) {
    if (!timestamp) return '';
    const date = new Date(typeof timestamp === 'string' ? 
      timestamp.replace(/-/g, '/') : 
      timestamp * 1000
    );
    
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  },
// 优化后的发送方法
async sendMessage() {
  if (!this.message.trim()) return;
  if (!this.selectedUser || !this.selectedUser.receiver || !this.selectedUser.receiver.user_id) {
    console.warn('请先选择一个聊天对象');
    return;
  }

  // 生成临时消息ID
  const tempId = `temp_${Date.now()}`;
  
  // 构建临时消息对象
  const tempMsg = {
    id: tempId,
    mid: tempId,
    userid: this.currentAgent.user_id,
    touid: this.selectedUser.receiver.user_id,
    type: "text",
    status: "sending",
    message: {
      content: this.message,
      type: "text",
    },
    create_time: new Date().getTime() / 1000,
    sender: {
      user_id: this.currentAgent.user_id,
      avatarUrl: this.currentAgent.avatarUrl,
      nickName: this.currentAgent.nickName
    },
    receiver: this.selectedUser.receiver
  };

  // 立即显示临时消息
  this.chatHistory.messages.push(tempMsg);
  this.scrollToBottom();

  try {
    // 确保连接已建立，然后发送
    await this.initWebSocket();

    // 发送WebSocket消息
    const wsMsg = {
      user_id: this.currentAgent.user_id,
      type: 'chat',
      msgtype: 'text',
      content: this.message,
      mid: tempId,
      to_user_id: this.selectedUser.receiver.user_id,
      obj: JSON.stringify({})
    };
    this.websocket.send(JSON.stringify(wsMsg));
    
    // 清空输入框
    this.message = '';

  } catch (error) {
    console.error('发送失败:', error);
    const index = this.chatHistory.messages.findIndex(m => m.id === tempId);
    if (index > -1) {
      this.$set(this.chatHistory.messages[index], 'status', 'failed');
    }
  }
},

 initWebSocket() {
  // 如果已经有一个正在进行的连接尝试，直接返回这个 Promise
  if (this.webSocketPromise) {
    return this.webSocketPromise;
  }

  // 如果已有连接且状态为 OPEN，直接返回一个已解决的 Promise
  if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
    return Promise.resolve();
  }

  // 关闭任何可能存在的旧连接
  this.closeWebSocket();

  const wsUrl = config.dev.socket;
  this.websocket = new WebSocket(wsUrl);

  const vm = this;

  // 创建一个新的 Promise 并存储它
  this.webSocketPromise = new Promise((resolve, reject) => {
    this.websocket.onopen = () => {
      console.log('WebSocket 连接已建立');
      vm.websocketRetryCount = 0;
      // 连接成功后，清除存储的 Promise
      vm.webSocketPromise = null;
      resolve();

      // 发送登录消息
      const loginMsg = {
        token: vm.currentAgent.user_id,
        type: 'login',
        imgUri: vm.currentAgent.avatarUrl
      };
      vm.websocket.send(JSON.stringify(loginMsg));
    };

    this.websocket.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        console.log('收到 WebSocket 消息', response);

        // 处理服务器推送的聊天消息
        if (response.type === 'chat') { // 假设服务器推送消息的 type 是 'chat_message'
          const formattedMessage = vm.formatIncomingMessage(response);
          // 使用 push 添加消息，这是正确的做法
          console.log('1',formattedMessage)
          vm.chatHistory.messages.push(formattedMessage);
              console.log('2',vm.chatHistory.messages)
              this.$forceUpdate()
          vm.$nextTick(() => {
            vm.scrollToBottom();
          });
        }

        // 处理消息发送确认 (ack)
        if (response.type === 'message_ack') {
          vm.handleMessageAck(response.data);
        }

      } catch (e) {
        console.error('解析 WebSocket 消息失败:', e);
      }
    };

    this.websocket.onerror = (error) => {
      console.error('WebSocket 错误:', error);
      // 出错后，清除存储的 Promise，允许下次重试
      vm.webSocketPromise = null;
      reject(error);
    };

    this.websocket.onclose = (event) => {
      console.log('WebSocket 连接已关闭, 代码:', event.code, '原因:', event.reason);
      // 连接关闭后，清除存储的 Promise
      vm.webSocketPromise = null;
      
      // 根据关闭码判断是否需要重连 (1000 是正常关闭)
      if (vm.isPageActive && event.code !== 1000) {
        vm.retryWebSocketConnection();
      }
    };
  });

  return this.webSocketPromise;
},

// 修改 closeWebSocket 方法，确保清除 Promise
closeWebSocket() {
  if (this.websocket) {
    // 清除重试计数器
    this.websocketRetryCount = 0;
    
    // 只有在连接打开或正在连接时才需要关闭
    if ([WebSocket.OPEN, WebSocket.CONNECTING].includes(this.websocket.readyState)) {
      this.websocket.close(1000, "手动关闭"); // 1000 是正常关闭码
    }
    this.websocket = null;
  }
  // 无论连接是否存在，都清除 Promise
  this.webSocketPromise = null;
},

// 新增方法：格式化收到的消息
formatIncomingMessage(response) {
  // 假设 response.data 包含了消息的主体
  const data = response.data; 

  // 构建 sender 和 receiver 对象
  const sender = {
    user_id: data.sender_id,
    avatarUrl: data.sender.avatarUrl || 'default-avatar.png', // 根据实际字段调整
    nickName: data.sender.nickName || '未知用户' // 根据实际字段调整
  };

  const receiver = {
    user_id: data.touid,
    avatarUrl: data.receiver.avatarUrl || 'default-avatar.png', // 根据实际字段调整
    nickName: data.receiver.nickName || '未知用户' // 根据实际字段调整
  };

  // 处理消息内容，如果是对象就字符串化，否则直接使用
  let messageContent = data.message.content;
  if (typeof messageContent === 'object' && messageContent !== null) {
    messageContent = JSON.stringify(messageContent);
  }

  return {
    id: parseInt(data.msg_id),
    mid: data._mid,
    userid: data.sender_id,
    touid: data.touid,
    type: data.message.type || 'text',
    content: messageContent, // 使用处理后的内容
    isSelf: data.sender_id === this.currentAgent.user_id, // 正确判断是否是自己发送的
    status: 'received',
    message: {
      content: messageContent,
      type: data.message.type || 'text',
    },
    create_time: data.create_time || Math.floor(Date.now() / 1000),
    sender: sender,
    receiver: receiver
  };
},
// 新增方法：获取用户头像
getUserAvatar(userId) {
  if (userId === this.currentAgent.user_id) return this.currentAgent.avatarUrl;
  const user = this.users.find(u => u.receiver.user_id === userId);
  return user ? user.receiver.avatarUrl : 'default-avatar.png';
},

// 新增方法：获取用户昵称
getUserNickname(userId) {
  if (userId === this.currentAgent.user_id) return this.currentAgent.nickName;
  const user = this.users.find(u => u.receiver.user_id === userId);
  return user ? user.receiver.nickName : '未知用户';
},



  initializeMessages() {
  this.messages = [
  {
  id: 1,
  content: '您好，请问有什么可以帮助您的吗？',
  time: '14:30',
  isSelf: true,
  avatar: this.currentAgent.avatar
  },
  {
  id: 2,
  content: '你好，我想咨询一下产品的相关问题',
  time: '14:31',
  isSelf: false,
  avatar: this.selectedUser.avatar
  }
  ];
  },
  getMyFriend(id){
      UserApi.getMyFriend({touid:id,user_id:this.currentAgent.user_id}).then(data => {
        console.log("getMyFriend",data);
        // data.data.list.data.shift() 
        this.users = data.data.list.data
        this.selectedUser = data.data.list.data[0]   
      }
      )
    },
    getChatList(id){
      UserApi.getChatList({touid:id,page:1}).then(data => {
        console.log("getChatList",data);
        // this.users = data.data.list.data    
      }
      )
    },
    async  getMsgList(userid, touid){

      try {
      const res = await UserApi.getMsgList({ userid, touid });
      // 使用Vue.set或修改原数组来触发响应式更新
      this.$set(this.chatHistory, 'messages', res.data.list.data.map(msg => ({
        ...msg,
        isSelf: msg.userid === this.currentAgent.user_id
      })));
      // 或者，如果chatHistory是一个响应式引用，可以直接替换数组
      // this.chatHistory.messages = [...]; // 注意这通常不会触发响应式更新，除非chatHistory本身是一个响应式引用
    } catch (error) {
      console.error('获取消息列表失败:', error);
    }
    },
    
  canRevoke(message) {
  // 假设消息发送后 2 分钟内可撤回
  const messageTime = new Date(message.time);
  const now = new Date();
  return (now - messageTime) <= 120000; // 2分钟 = 120000毫秒
  },
  revokeMessage(messageId) {
  const index = this.messages.findIndex(m => m.id === messageId);
  if (index !== -1) {
  this.messages.splice(index, 1);
  }
  }
  }
  };
  </script>
  <style scoped>
  .custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #e0d7cb #EDF2F7;
  }
  .custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
  background: #EDF2F7;
  }
  .payment-reminder-wrapper {
  width: 100%;
  margin: 10px 0;
}
.search-container {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.search-input {
  width: 100%;
  padding: 8px 12px 8px 32px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  outline: none;
}

.search-input:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
}

.payment-reminder {
  background-color: #fff8e6;
  border: 1px solid #ffd700;
  border-radius: 8px;
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-reminder:hover {
  background-color: #fff0cc;
}

.reminder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #e67e22;
}

.reminder-content {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #666;
}

.amount {
  margin-top: 5px;
  font-weight: bold;
  color: #e74c3c;
}
  .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #CBD5E0;
  border-radius: 3px;
  }
  input[type="text"] {
  font-size: 14px;
  }
  input[type="text"]::placeholder {
  color: #A0AEC0;
  }
  .user-card {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 8px;
  cursor: pointer;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

.message-container {
  display: flex;
  align-items: center;
}

.file-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}

.file-container:hover {
  background-color: #ebebeb;
}

.file-name {
  font-size: 14px;
  color: #333;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 可以添加文件图标 */
.file-container::before {
  content: "📄";
  margin-right: 8px;
  font-size: 16px;
}

.user-name {
  font-size: 14px;
  font-weight: bold;
}

/* 语音消息样式 */
.voiceaa {
  position: relative;
  width: 100px;
  height: 40px;
  background-color: #e6f7ff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 商品卡片样式 */
.isclipboardText {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.item {
  display: flex;
  padding: 10px;
  cursor: pointer;
}

.product-cover {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.product-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.product-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.already-sale {
  font-size: 12px;
  color: #999;
}

.price {
  color: #ff4d4f;
  font-weight: bold;
}

.price .num {
  font-size: 16px;
}

.mt20 {
  margin-top: 10px;
}
  </style>
  


// WEBPACK FOOTER //
// src/views/service/index/chat.vue